import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { ShotSelectLogo } from './ShotSelectLogo';

interface BrandBarProps {
  title: string;
  subtitle?: string;
  back?: boolean;
  rightSlot?: React.ReactNode;
  brandLogoUrl?: string | null;
}

export function BrandBar({ title, subtitle, back, rightSlot, brandLogoUrl }: BrandBarProps) {
  const navigate = useNavigate();
  return (
    <header className="flex items-center gap-2.5 px-4 pt-3 pb-2 flex-shrink-0">
      {back && (
        <button
          onClick={() => navigate(-1)}
          aria-label="Back"
          className="w-11 h-11 rounded-full bg-[var(--surface-secondary)] border border-[var(--border-subtle)] grid place-items-center text-[var(--text-secondary)] active:scale-95 transition-transform"
        >
          <ChevronLeft size={18} strokeWidth={2} />
        </button>
      )}
      {brandLogoUrl ? (
        <img
          src={brandLogoUrl}
          className="w-7 h-7 rounded-lg object-contain border border-[var(--border-default)] bg-[var(--surface-tertiary)]"
          alt=""
        />
      ) : !back ? (
        <div className="w-7 h-7 rounded-lg bg-[var(--surface-tertiary)] border border-[var(--border-default)] grid place-items-center text-[var(--text-primary)]">
          <ShotSelectLogo className="h-4 w-4" />
        </div>
      ) : null}

      <div className="flex-1 min-w-0 leading-tight">
        <div className="text-[13px] font-semibold text-[var(--text-primary)] truncate">
          {title}
        </div>
        {subtitle && (
          <div className="text-[12px] uppercase tracking-wider text-[var(--text-tertiary)] truncate">
            {subtitle}
          </div>
        )}
      </div>
      {rightSlot}
    </header>
  );
}
